import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, platformsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, platformsActions);

export default slice.reducer;
